import { Component, input, signal } from '@angular/core';

export type GridColumns = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

@Component({
  selector: 'app-grid',
  imports: [],
  template: `
    <div 
      [class]="gridClasses"
      [style.gap]="gap()">
      <ng-content></ng-content>
    </div>
  `,
  styles: []
})
export class GridComponent {
  columns = input<GridColumns>(12);
  gap = input<string>('1rem');
  responsive = input<boolean>(true);
  align = input<'start' | 'center' | 'end' | 'stretch'>('stretch');
  justify = input<'start' | 'center' | 'end' | 'space-between' | 'space-around' | 'space-evenly'>('start');

  get gridClasses(): string {
    const classes = ['grid'];
    
    // Base columns
    classes.push(`grid-cols-${this.columns()}`);
    
    // Responsive breakpoints
    if (this.responsive()) {
      classes.push('grid-cols-1', 'sm:grid-cols-2', 'md:grid-cols-3', 'lg:grid-cols-4');
    }
    
    // Alignment
    classes.push(`items-${this.align()}`);
    classes.push(`justify-${this.justify()}`);
    
    return classes.join(' ');
  }
}

